<template>
  <div>
    <v-card class="card   mx-auto">
      <v-card-title style="background: #bc0000;height: 40px" class="pb-5 d-flex justify-center align-content-center text-center">
        <span style="color: #ffffff; font-weight: 500; font-size: 20px">Cancelar pedido</span>
      </v-card-title>
      <v-row cols="12" class=" mx-3">
        <v-col cols="12">
          <label>Motivo do cancelamento</label>
          <v-textarea
              name="input-7-1"
              class="textArea "
              rows="2"
              outlined
              hide-details
              :rules="[v => !!v || 'Campo obrigatório']"
              placeholder="Digite o motivo do cancelamento"
              v-model="descriptionOfCancellation"
           ></v-textarea>
        </v-col>
      </v-row>
      <v-row cols="12" class=" mx-3">
        <v-col cols="6" class="d-flex justify-space-between">
          <v-btn
               elevation="0"
              class="cancelBtn"
              @click="close"
          >
            Manter pedido
          </v-btn>
        </v-col>
        <v-col cols="6" class="d-flex justify-space-between">
          <v-btn

              elevation="0"
              class="okBtn white--text"
              @click="action"
          >
            Cancelar pedido
          </v-btn>

        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style scoped>
.card {
  background: #ffffff !important;
  border: 1px solid #dadada;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 7px !important;
}

.okBtn {
  transition: 0.3s;
  font-weight: bold !important;
  box-sizing: border-box !important;
  background: #bc0000 !important;
  width: 100%;
  height: 38px !important;
  color: #ffffff;
  border-radius: 5px !important;
}

.okBtn:hover {
  color: #fff !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2) !important;
}

.cancelBtn {
  transition: 0.3s;
  width: 100%;
  height: 38px !important;
  font-weight: bold !important;
  background-color: #ffffff !important;
  color: #000000 !important;
  border: 1.5px solid #2d3038 !important;
  box-sizing: border-box !important;
  border-radius: 5px !important;
}

.cancelBtn:hover {
  color: #fff !important;
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 29px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #bc0000;
}

.observation {
  font-family: Roboto;
  font-style: normal;
  color: grey;
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #232021;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}
</style>

<script>
import Vue from "vue";
import ApiService from "../../../services/ApiService";

export default {
  name: "CancelOrderModal",

  props: {
    order: {type: Object, required: true, default: Object},
  },

  data: () => ({
    loading: false,
    descriptionOfCancellation: null,
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit("close");
    },

    async action() {
      try {
        if (!this.descriptionOfCancellation) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: 'Preencha o motivo do cancelamento!',
            trace: null,
          });
          return
        }
        const body = {
          ...this.order,
          descriptionOfCancellation: this.descriptionOfCancellation,
        }
        this.$emit("close");

        const {statusCode, message, content} = await this.apiService.post(`order/cancel-by-customer`, body)


        if(statusCode != 200){
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: 'O pedido não pode ser cancelado, entre em contato com o suporte via WhatsApp.',
            trace: null,
          });
          this.$emit("loadOrder");
          return
        }

        if(content.paymentMethod == 0){
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: 'Pedido cancelado com sucesso!',
            trace: null,
          });
          this.$emit("loadOrder");
          return
        }
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "warning",
          title: "",
          message: 'Pedido cancelado com sucesso, entre em contato com o suporte via WhatsApp para ser reembolsado.',
          trace: null,
        });
        this.$emit("loadOrder");
      }catch (e) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: 'O pedido não pode ser cancelado, entre em contato com o suporte via WhatsApp.',
          trace: null,
        });
      }
    },
    async cancelViaCustomer() {
      try {

      } catch (e) {

      }
    },
  },
};
</script>
